import React from "react";

import clsx from "clsx";

import styles from "./CartAddLink.module.scss";

type CartAddLinkProps = {
  title: string;
  onClick: () => void;
  disabled?: boolean;
};

// カート追加ボタン、マイページ移動ボタンを統合したコンポーネント
export function CartAddLink({ title, onClick, disabled }: CartAddLinkProps) {
  return (
    <button
      type="button"
      className={clsx(styles.oneClickChange, "text__center", {
        [styles.disabled]: disabled,
      })}
      disabled={disabled}
    >
      <span className={clsx("text__m text__bold", styles.oneClickChangeText)} onClick={onClick}>
        {title}
      </span>
    </button>
  );
}
